import type { ManualDiscountDraft } from '../types';
import { getFormattedPrice } from '@tools/utils/common.tsx';

export const describeManualDiscount = (
  discount: ManualDiscountDraft,
  currency?: string,
): string => {
  if (discount.mode === 'percentage') {
    return `${(discount.value * 100).toFixed(0)}% · ${discount.reason}`;
  }
  return `${getFormattedPrice(discount.value, currency)} · ${discount.reason}`;
};
